import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { quillEditor } from 'vue-quill-editor';
import { uploadFile } from '../systemScene/request';
import quillConfig from '@/views/components/editor/quill-config.js';
import { getBase64, isImage, isVideo, isPDF, isExcel, isWord } from '@/views/claim/demageManage/utils';
import { accountResource } from '../customerMessageManagement/request';
import { newMessageStore } from './request';
import previewModal from '@/views/claim/demageManage/previewModal.vue';
import { cryptoDecrypt } from '@/utils/aes';
import moment from 'moment';
export default {
  data() {
    return {
      form: {
        title: '',
        content: '',
        fileList: [],
        displayForm: '',
        sendTime: '',
        sendDateTime: '',
        sendTimeHour: '',
        sendMinuteuHour: '',
        usersId: []
      },
      action: uploadFile,
      quillOption: quillConfig,
      accountTreeData: [],
      props: {
        multiple: true
      },
      loading: false,
      previewVisible: false,
      previewSrc: '',
      currentPreviewIndex: 0,
      fileType: ''
    };
  },
  components: {
    quillEditor,
    previewModal
  },
  computed: {
    rules() {
      return {
        title: [{
          required: true,
          message: this.$t('请输入') + this.$t('消息标题'),
          trigger: 'blur'
        }, {
          min: 2,
          max: 50,
          message: this.$t('请输入2-50字符'),
          trigger: 'blur'
        }],
        content: [{
          required: true,
          validator: this.checkEditorCont,
          trigger: 'change'
        }],
        displayForm: [{
          required: true,
          message: this.$t('请选择') + this.$t('展现形式'),
          trigger: 'change'
        }],
        usersId: [{
          required: true,
          message: this.$t('请选择') + this.$t('接收对象'),
          trigger: 'change'
        }],
        sendTime: [{
          required: true,
          validator: this.checkSendTime,
          trigger: 'change'
        }]
      };
    },
    computedAccountTreeData() {
      let loop = data => {
        if (Array.isArray(data) && data.length) {
          return data.map(item => {
            if (item.value === 'ALL') {
              item.label = this.$t('全部');
            } else if (item.label === '系统管理员') {
              item.label = this.$t('系统管理员');
            }
            if (item.children && item.children.length) {
              item.children = loop(item.children);
            }
            return item;
          });
        } else {
          return [];
        }
      };
      return loop(this.accountTreeData);
    }
  },
  created() {
    this.getAccountResource();
  },
  methods: {
    timechange() {
      if (this.form.sendTime === 'SEND_NOW') {
        this.form.sendDateTime = '';
        this.form.sendTimeHour = '';
        this.form.sendMinuteuHour = '';
      }
    },
    changeTimeValidate() {
      this.$refs.ruleForm.validateField('sendTime');
    },
    checkSendTime(rule, value, callback) {
      if (!this.form.sendTime) {
        callback(new Error(this.$t('请选择') + this.$t('发送时间')));
      } else if (this.form.sendTime === 'TIMED_SEND') {
        if (!this.form.sendDateTime) {
          callback(new Error(this.$t('请选择') + this.$t('发送时间')));
        } else if (!this.form.sendTimeHour && this.form.sendTimeHour != 0) {
          callback(new Error(this.$t('请选择') + this.$t('发送时间')));
        } else if (!this.form.sendMinuteuHour && this.form.sendMinuteuHour != 0) {
          callback(new Error(this.$t('请选择') + this.$t('发送时间')));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    // 校验富文本是否有真实内容
    checkEditorCont(rule, value, callback) {
      const editorContent = this.$refs.myTextEditor.quill.root.innerHTML;
      // 使用DOMParser解析HTML字符串为DOM对象
      const parser = new DOMParser();
      const doc = parser.parseFromString(editorContent, 'text/html');
      // 获取解析后的文本内容
      const textContent = doc.body.textContent || '';
      const trimContent = textContent.trim();
      if (!trimContent && !editorContent.includes('<img')) {
        callback(new Error(this.$t('请输入') + this.$t('消息内容')));
      } else if (trimContent && trimContent.length > 1024) {
        callback(new Error(this.$t('请输入1-1024字符')));
      } else {
        callback();
      }
    },
    beforeUpload(file, info) {
      //上传文件前限制最多只能上传10个附件
      return new Promise((resolve, reject) => {
        const typeReg = /(docx|doc|xlsx|xls|mp4|jpg|pdf|jpeg|png)$/;
        const filename = (file === null || file === void 0 ? void 0 : file.name) || '';
        const imgSuffix = filename.substring(filename.lastIndexOf('.') + 1).toLowerCase();
        const isFileTypeError = typeReg.test(imgSuffix);
        let fileSizes = file.size / 1024 / 1024;
        if (this.form.fileList.length >= 10) {
          this.$message.error(this.$t('最多上传10条附件'));
          reject(false);
        } else if (!isFileTypeError) {
          this.$message.error(this.$t('上传格式错误'));
          reject(false);
        } else if (fileSizes > 100) {
          this.$message.error(this.$t('文件大小超过100mb'));
          reject(false);
        } else {
          resolve(true);
        }
      });
    },
    handleChange(info) {
      if (info.file.status === 'done') {
        if (info.file.response.code != 200) {
          this.$message.error(info.file.response.message);
          this.form.fileList[this.form.fileList.length - 1].status = 'error';
        }
      }
      let fileList = info.fileList;
      this.form.fileList = fileList.map(file => {
        if (file.response) {
          file.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(file.response.data).fileTempUrl : file.response.data.fileTempUrl;
        }
        return file;
      });
    },
    async previewFile(file) {
      //文件预览 图片和视频弹窗预览 其他文件新打开页面
      this.fileType = '';
      let type = file.url.substring(file.url.lastIndexOf('.')).substring(1).toLowerCase();
      if (isImage(type)) {
        this.fileType = 'image';
      }
      if (isVideo(type)) {
        this.fileType = 'video';
      }
      //excel
      if (isExcel(type)) {
        const urlid = 'https://view.officeapps.live.com/op/view.aspx?src=';
        this.previewXLSX = urlid + file.url;
        window.open(this.previewXLSX);
      }
      // doc格式
      if (isWord(type)) {
        const urlid = 'https://view.officeapps.live.com/op/view.aspx?src=';
        this.previewDocx = urlid + file.url;
        window.open(this.previewDocx);
      }
      this.isPDFShow = isPDF(type);
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      if (this.fileType === 'image' || this.fileType === 'video') {
        this.previewSrc = file.url || file.preview;
        this.currentPreviewIndex = this.form.fileList.findIndex(item => item.uid === file.uid);
      } else if (this.isPDFShow) {
        this.previewPDF = file.url || file.response.data.fileTempUrl;
        window.open(this.previewPDF);
        return;
      } else {
        window.open(file.url || file.response.data.fileTempUrl);
        return;
      }
      this.previewVisible = true;
    },
    getAccountResource() {
      let params = {
        customerId: this.form.customerId
      };
      if (this.loading) {
        return;
      }
      this.loading = true;
      accountResource(params).then(res => {
        let loop = data => {
          if (Array.isArray(data) && data.length) {
            return data.map(item => {
              let obj = {
                label: item.name || item.nickName,
                value: item.id || '',
                disabled: false
              };
              if (item.children && item.children.length) {
                obj.children = loop(item.children);
                obj.children.unshift({
                  label: '全部',
                  value: 'ALL',
                  disabled: false
                });
              }
              return obj;
            });
          } else {
            return [];
          }
        };
        let data = [{
          label: '全部',
          value: 'ALL',
          children: [{
            label: '全部',
            value: 'ALL'
          }]
        }, {
          label: '系统管理员',
          value: '0',
          children: [{
            label: '全部',
            value: 'ALL'
          }]
        }];
        let admin = res.admin.map(item => {
          return {
            label: item.nickName,
            value: item.id
          };
        });
        data[1].children.push(...admin);
        let customerAdmin = loop(res.customerAdmin);
        data.push(...customerAdmin);
        this.accountTreeData = data;
      }).finally(() => {
        this.loading = false;
      });
    },
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let fileUploadComplete = true;
          this.form.fileList.forEach(item => {
            if (item.status !== 'done') {
              fileUploadComplete = false;
            }
          });
          if (!fileUploadComplete) {
            this.$message.error(this.$t('文件上传中，请稍后再试'));
            return;
          }
          let fileList = [];
          this.form.fileList.forEach(item => {
            let obj = {
              uid: item.uid,
              name: item.name,
              url: item.url,
              status: item.status
            };
            fileList.push(obj);
          });
          let params = {
            title: this.form.title.trim(),
            content: this.form.content.trim(),
            uploadFiles: fileList ? JSON.stringify(fileList) : '',
            displayForm: this.form.displayForm,
            type: 'INTERNAL_MAIL',
            isSystemTemplate: '1',
            messageCategory: 'SYSTEM_MESSAGE'
          };
          let sendTime = {
            type: this.form.sendTime,
            time: ''
          };
          if (sendTime.type === 'TIMED_SEND') {
            let date = this.form.sendDateTime + ' ' + this.form.sendTimeHour + ':' + this.form.sendMinuteuHour;
            sendTime.time = date;
            let current = moment().format('YYYY-MM-DD HH:mm:ss');
            let time = moment(date).diff(moment(current), 'minutes');
            if (time < 5) {
              this.$message.error(this.$t('选择时间请在当前时间5分钟之后'));
              return;
            }
          }
          params.sendTime = JSON.stringify(sendTime);
          this.collectAccountObj();
          let user = [];
          Object.keys(this.accountObj).forEach(item => {
            var _this$accountObj$item;
            user.push({
              customerId: item,
              userId: (_this$accountObj$item = this.accountObj[item]) === null || _this$accountObj$item === void 0 ? void 0 : _this$accountObj$item.join(',')
            });
          });
          params.user = JSON.stringify(user);
          newMessageStore(params).then(res => {
            this.$message.success(this.$t('发送成功'));
            this.$router.push({
              name: 'messageLog'
            });
          });
        }
      });
    },
    collectAccountObj() {
      this.accountObj = {};
      this.form.usersId.forEach(item => {
        var _this$accountObj$item2;
        if (((_this$accountObj$item2 = this.accountObj[item[0]]) === null || _this$accountObj$item2 === void 0 ? void 0 : _this$accountObj$item2.length) > 0) {
          this.accountObj[item[0]].push(item[1]);
        } else {
          this.accountObj[item[0]] = [item[1]];
        }
      });
    },
    changeAccount(value) {
      if (value && value.length && value[0][0] === 'ALL' && value[0][1] === 'ALL') {
        this.accountTreeData.forEach(item => {
          if (item.children && item.value !== 'ALL') {
            item.children.forEach(child => {
              child.disabled = true;
            });
          }
        });
      } else {
        this.collectAccountObj();
        this.accountTreeData.forEach(item => {
          if (item.children) {
            let selectValue = this.accountObj[item.value];
            if (item.value === 'ALL') {
              item.children.forEach(child => {
                child.disabled = value.length === 0 ? false : true;
              });
            } else {
              item.children.forEach(child => {
                if (selectValue && (selectValue === null || selectValue === void 0 ? void 0 : selectValue.indexOf('ALL')) !== -1 && child.value !== 'ALL') {
                  child.disabled = true;
                } else if (selectValue && (selectValue === null || selectValue === void 0 ? void 0 : selectValue.length) > 0 && (selectValue === null || selectValue === void 0 ? void 0 : selectValue.indexOf('ALL')) === -1 && child.value === 'ALL') {
                  child.disabled = true;
                } else {
                  child.disabled = false;
                }
              });
            }
          }
        });
      }
      this.accountTreeData = [...this.accountTreeData];
    },
    cancelPre() {
      this.previewVisible = false;
      this.previewSrc = '';
      this.currentPreviewIndex = 0;
    }
  }
};